var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var Heading5Icon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 36,
    glyphHeight: 36
  }), React.createElement("path", {
    d: "M6.268 9.736L4.056 9.4V8H11.672V9.4L9.264 9.736V17.268H19.12V9.736L16.852 9.4V8H24.356V9.4L22.144 9.736V27.152L24.356 27.432V28.804H16.824V27.432L19.12 27.152V19.004H9.264V27.152L11.7 27.432V28.804H4V27.432L6.268 27.152V9.736Z",
    fill: "black"
  }), React.createElement("path", {
    d: "M26.5552 27.5645C26.8592 27.5805 27.0912 27.5885 27.2512 27.5885C27.8032 27.5885 28.3032 27.4765 28.7512 27.2525C29.2072 27.0285 29.5672 26.7245 29.8312 26.3405C30.0952 25.9485 30.2272 25.5165 30.2272 25.0445C30.2272 24.4445 30.0832 24.0125 29.7952 23.7485C29.5072 23.4845 29.0912 23.3525 28.5472 23.3525C28.2832 23.3525 27.9912 23.3885 27.6712 23.4605C27.3592 23.5325 27.0992 23.6165 26.8912 23.7125L26.4952 23.4365L27.0712 19.0085H30.7792L30.8992 18.7805H31.7272L31.4752 20.2805H28.1872L27.6952 22.7765C27.9272 22.6565 28.2032 22.5525 28.5232 22.4645C28.8512 22.3685 29.1992 22.3205 29.5672 22.3205C30.3832 22.3205 31.0072 22.5325 31.4392 22.9565C31.8792 23.3805 32.0992 23.9805 32.0992 24.7565C32.0992 25.4445 31.8952 26.0645 31.4872 26.6165C31.0872 27.1765 30.5272 27.6125 29.8072 27.9245C29.0952 28.2445 28.2912 28.4045 27.3952 28.4045C27.0912 28.4045 26.8112 28.3765 26.5552 28.3205V27.5645Z",
    fill: "black"
  }));
};
export var Heading5IconGlyph = function (props) {
  return React.createElement(Heading5Icon, __assign({}, props, {
    variant: 'glyph'
  }));
};